import { Flex, Image, useToast } from '@chakra-ui/react'
import { useEffect, useState } from 'react'
import { FaPlus } from 'react-icons/fa'
import { ButtonCmp } from '../../../../components/ButtonCmp'
import { ModalDelete } from '../../../../components/ModalDelete'
import { Paginador } from '../../../../components/Paginador'
import { useAuth } from '../../../../contexts/AuthContext'
import { ISquad } from '../../../../interfaces'
import { appApi } from '../../../../services/appApi'
import { parseJwt } from '../../../../services/token'
import { Body } from '../../../Layouts/Body'
import { NavBar } from '../Components/NavBar'
import { SectionHeader } from '../Components/SectionHeader'
import { ModalPessoas } from '../Components/ModalPessoas'
import { SquadGestaoCard } from './Components/SquadGestaoCard'
import { SquadModal } from './Components/SquadModal'
import { Main } from './styles'

interface INavLink {
  to: string
  linkTitle: string
  exact?: boolean
}

const TIPO_TAG_SQUAD = 2

export const SquadsDesenvolvimento: React.FC = () => {
  const toast = useToast()
  const { permitirFuncao } = useAuth()

  const [IsLoading, setIsLoading] = useState(false)
  const [Pagina, setPagina] = useState(0)
  const [Tamanho, setTamanho] = useState(15)
  const [Squads, setSquads] = useState<ISquad[]>([])
  const [SquadSelecionado, setSquadSelecionado] = useState<ISquad>()
  const [ModalCreateIsOpen, setModalCreateIsOpen] = useState(false)
  const [ModalUpdateIsOpen, setModalUpdateIsOpen] = useState(false)
  const [ModalDeleteIsOpen, setModalDeleteIsOpen] = useState(false)
  const [SquadPessoas, setSquadPessoas] = useState<ISquad>()

  function ObterRotas(): INavLink[] {
    const rotas: INavLink[] = []
    if (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'visao-geral')) {
      rotas.push({
        to: '/Organograma/Dashboard',
        linkTitle: 'Visão geral'
      })
    }

    if (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'areas')) {
      rotas.push({
        to: '/Organograma/Departamentos',
        linkTitle: 'Áreas'
      })
    }

    if (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'funcoes')) {
      rotas.push({
        to: '/Organograma/Cargos',
        linkTitle: 'Cargos'
      })
    }

    if (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'squads')) {
      rotas.push({
        to: '/Organograma/Squads',
        linkTitle: 'Squads'
      })
    }

    if (parseJwt().adm === 'True' || permitirFuncao('Organograma', 'colaboradores')) {
      rotas.push({
        to: '/Organograma/Colaboradores',
        linkTitle: 'Colaboradores'
      })
    }
    return rotas
  }

  function getSquads(): void {
    setIsLoading(true)
    appApi.get('Organograma/VisualizarSquads')
      .then(res => {
        const data: ISquad[] = res.data
        setSquads(data.sort((a, b) => a.nome.localeCompare(b.nome)))
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function NomeValido(nome: string, idIgnorado?: string): boolean {
    const nomeTratado = nome.trim().toLowerCase()
    if (nomeTratado === '') {
      toast({
        title: 'Informe o nome do squad',
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return false
    }

    if (Squads.some(e => e.id !== idIgnorado && e.nome.trim().toLowerCase() === nomeTratado)) {
      toast({
        title: 'Já existe um squad com este nome',
        status: 'error',
        isClosable: false,
        position: 'top-right',
        duration: 4000
      })
      return false
    }
    return true
  }

  function onCreateSquad(nome: string): void {
    if (!NomeValido(nome)) return
    appApi.post('Tag', { texto: nome.trim(), tipo: TIPO_TAG_SQUAD })
      .then(() => {
        setModalCreateIsOpen(false)
        getSquads()
      })
      .catch(err => console.log(err))
  }

  function onUpdateSquad(nome: string): void {
    if (!SquadSelecionado || !NomeValido(nome, SquadSelecionado.id)) return
    appApi.put(`Tag/${SquadSelecionado.id}`, { texto: nome.trim(), tipo: TIPO_TAG_SQUAD })
      .then(() => {
        onCloseModalUpdate()
        getSquads()
      })
      .catch(err => console.log(err))
  }

  function onDeleteSquad(): void {
    if (!SquadSelecionado) return
    appApi.delete(`Tag/${SquadSelecionado.id}`)
      .then(getSquads)
      .catch(err => console.log(err))
  }

  function onCloseModalUpdate(): void {
    setModalUpdateIsOpen(false)
    setSquadSelecionado(undefined)
  }

  function onCloseModalDelete(): void {
    setModalDeleteIsOpen(false)
    setSquadSelecionado(undefined)
  }

  useEffect(() => {
    getSquads()
  }, [])

  useEffect(() => {
    setPagina(0)
  }, [Tamanho])

  // após excluir o último item da página, volta para a última página que ainda existe
  useEffect(() => {
    const ultimaPagina = Math.max(Math.ceil(Squads.length / Tamanho) - 1, 0)
    if (Pagina > ultimaPagina) setPagina(ultimaPagina)
  }, [Squads])

  return (
    <Body isLoading={IsLoading}>
      <Main>
        <ModalDelete
          isOpen={ModalDeleteIsOpen}
          onRequestClose={onCloseModalDelete}
          onConfirm={onDeleteSquad}
          center
          message={'Deseja realmente excluir este squad?'}
        />

        <ModalPessoas
          isOpen={SquadPessoas !== undefined}
          titulo={`Colaboradores do squad ${SquadPessoas?.nome ?? ''}`}
          pessoas={[...(SquadPessoas?.colaboradores ?? [])].sort((a, b) => a.nome.localeCompare(b.nome))}
          onClose={() => setSquadPessoas(undefined)}
        />

        <SquadModal
          isOpen={ModalCreateIsOpen}
          titulo='Novo squad'
          onRequestClose={() => setModalCreateIsOpen(false)}
          onConfirm={onCreateSquad}
        />

        <SquadModal
          isOpen={ModalUpdateIsOpen}
          titulo='Editar squad'
          nomeInicial={SquadSelecionado?.nome}
          onRequestClose={onCloseModalUpdate}
          onConfirm={onUpdateSquad}
        />

        <NavBar
          title="Organograma"
          navLinks={ObterRotas()}
        />

        <SectionHeader title="Squads" Button={parseJwt().adm === 'True' ? <ButtonCmp onClick={() => setModalCreateIsOpen(true)} leftIcon={<FaPlus/>} VarColor='Green2'>Adicionar squad</ButtonCmp> : undefined}/>

        {!IsLoading && Squads.length === 0 && (
          <Flex alignItems={'center'} color={'var(--Azul)'} justifyContent={'center'} mt={'2rem'}>
            <Image className='sah_Img' height={'20rem'} src='https://sigah.blob.core.windows.net/assets/NovaSAH.png' />
            <h3>Nenhum squad cadastrado.</h3>
          </Flex>
        )}

        <Paginador
          next={(e) => setPagina(e)}
          prev={(e) => setPagina(e)}
          tamanho={Tamanho}
          setTamanho={(e) => setTamanho(e)}
          paginaAtual={Pagina}
          qtdElementos={Squads.length}
          opcoesTamanho={['15', '30', '45', '90']}
          hideTop
        >
          <section style={{ marginTop: '1.5rem', marginBottom: '1rem' }}>
            {
              Squads.slice(Pagina * Tamanho, (Pagina + 1) * Tamanho).map((e) => {
                return (
                  <SquadGestaoCard
                    key={e.id}
                    squad={e}
                    onEdit={() => { setSquadSelecionado(e); setModalUpdateIsOpen(true) }}
                    onDelete={() => { setSquadSelecionado(e); setModalDeleteIsOpen(true) }}
                    onVerPessoas={() => setSquadPessoas(e)}
                  />
                )
              })
            }
          </section>
        </Paginador>
      </Main>
    </Body>
  )
}
